import { render, staticRenderFns } from "./BidCostTypeSettings.vue?vue&type=template&id=0dd48423&"
import script from "./BidCostTypeSettings.vue?vue&type=script&lang=js&"
export * from "./BidCostTypeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports